import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { TaskModelRef } from "@src/views/project-tasks/domain/task.model";
import { MyTaskDashboardStore } from "../domain/dashboard.model";

export const fetchRiskyProjects = createAsyncThunk<any, {projectType:string} >("dashboard/fetchRiskyProjects", async ({projectType}) => {
  const url = `${AppConstants.api}/project/risky?projectType=${projectType}`;
  const response = await api.get<ApplicationResponse<any[]>>(
    url
  );
  return response.data.data ||[];
});

export const fetchActionsData = createAsyncThunk<any, {isDelayed:boolean,userId:string,
projectType:string}>("dashboard/fetchActionsData", async ({isDelayed,userId,projectType}) => {
  let url = `${AppConstants.api}/dashboard/`;
  if(isDelayed){
    url+=`delayed_actions`;
  } 
  else{
    url+=`my_actions`;
  } 
  const response = await api.get<ApplicationResponse<any[]>>(url,{
    params:{
      id:userId,
      type:projectType
    }
  });
  return response.data.data || [];
});

  export const fetchUsersTasksListData = createAsyncThunk<TaskModelRef[],  { projectType: "npms" | "eci" | "custom", id:string } 
>("dashboard/fetchUsersTasksListData", async ({projectType,id}) => {
  const url = `${AppConstants.api}/dashboard/user-tasks?projectType=${projectType}&id=${id}`;
  const response = await api.get<ApplicationResponse<TaskModelRef[]>>(
    url
  );
  return response.data.data || [];
});


  export const fetchUsersAssignedTasksListData = createAsyncThunk<TaskModelRef[],  { projectType: "npms" | "eci" | "custom", id:string , status?:string | null ; departmentId?: string | null  } 
>("dashboard/fetchUsersAssignedTasksListData", async ({projectType,id,status="", departmentId}) => {
  let url = `${AppConstants.api}/dashboard/user-assignedTasks?projectType=${projectType}&id=${id}`;
  if(status && status!== "undefined")  url=url+`&status=${status}`;
  if (departmentId && departmentId!== "undefined") url = url + `&departmentId=${departmentId}`;

  const response = await api.get<ApplicationResponse<TaskModelRef[]>>(
    url
  );
  return response.data.data || [];
});

  export const fetchUsersApprovalTasksListData = createAsyncThunk<TaskModelRef[],  { projectType: "npms" | "eci" | "custom", id:string } 
>("dashboard/fetchUsersApprovalTasksListData", async ({projectType,id}) => {
  const url = `${AppConstants.api}/dashboard/user-approvalTasks?projectType=${projectType}&id=${id}`;
  const response = await api.get<ApplicationResponse<TaskModelRef[]>>(
    url
  );
  return response.data.data || [];
});
  export const fetchUsersDelayedTasksListData = createAsyncThunk<TaskModelRef[],  { projectType: "npms" | "eci" | "custom", id:string } 
>("dashboard/fetchUsersDelayedTasksListData", async ({projectType,id}) => {
  const url = `${AppConstants.api}/dashboard/user-delayed-tasks?projectType=${projectType}&userId=${id}`;
  const response = await api.get<ApplicationResponse<TaskModelRef[]>>(
    url
  );
  return response.data.data || [];
});



const myTaskSlice = createSlice({
  name: "myTaskDashboard",
  initialState: {
    myTaskMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    
    
  } as MyTaskDashboardStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersTasksListData.pending, (state, action) => {
        state.myTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUsersTasksListData.fulfilled, (state, action) => {
        state.myTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUsersTasksListData.rejected, (state, action) => {
        state.myTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchUsersAssignedTasksListData.pending, (state, action) => {
        state.myTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUsersAssignedTasksListData.fulfilled, (state, action) => {
        state.myTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUsersAssignedTasksListData.rejected, (state, action) => {
        state.myTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchUsersApprovalTasksListData.pending, (state, action) => {
        state.myTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUsersApprovalTasksListData.fulfilled, (state, action) => {
        state.myTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUsersApprovalTasksListData.rejected, (state, action) => {
        state.myTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchUsersDelayedTasksListData.pending, (state, action) => {
        state.myTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUsersDelayedTasksListData.fulfilled, (state, action) => {
        state.myTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUsersDelayedTasksListData.rejected, (state, action) => {
        state.myTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchRiskyProjects.pending, (state, action) => {
        state.myTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchRiskyProjects.fulfilled, (state, action) => {
        state.myTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchRiskyProjects.rejected, (state, action) => {
        state.myTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchActionsData.pending, (state, action) => {
        state.myTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchActionsData.fulfilled, (state, action) => {
        state.myTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchActionsData.rejected, (state, action) => {
        state.myTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
    
      
      
     
  },
});

export default myTaskSlice.reducer;
